import React , { Component } from 'react';
import Recapitulation from './Recapitulation';
import DashboardMobile from './Dashboard';
import Step from './Step';

/*image dashboard*/
import imgDemandeur from '../img/step1.png' ;
import imgEnfant from '../img/step2.png' ;
import imgConjoint from '../img/step3.png' ;
import imgLogement from '../img/step4.png' ;
import imgRessources from '../img/step5.png' ;
import imgPreFin from '../img/step6.png' ;

import {init_recap} from './recap-data';

class Simulateur extends Component {

	state = { 
		step : 1,
		demandeur : {
			"role":"demandeur",
			"gir": "gir_6",
            "pensions_alimentaires_percues": 0,
            "pensions_alimentaires_versees_individu": {
            },
		},
		famille : {
			"parents":["individu"],
			"enfants":[],
			"rsa_isolement_recent":false,
		},
		menage : {
			"personne_de_reference":["individu"],
			"enfants":[],
			"conjoint":[]
		},
		foyer_fiscal : {
			"declarants":["individu"],
			"personnes_a_charge":[]
		},
		individus: {},
		showDashboard :true,
		recapData :{
		  demandeur: {
	        title: 'Mon profil',
	        icon_img: imgDemandeur,
	        page: '#!/step1',
	        available_datas: [],
	        no_data: 'Aucune donnée saisie',
	        step: 1
	      },
	      enfants: {
	        title: 'Mes enfants a charge(s)',
	        page: '#!/step2',
	        icon_img: "/build/static/media/step2.b4a377e50ff3712ad5bb.png",
	        available_datas: [],
	        no_data: 'Aucune donnée saisie',
	        step: 2
	      },
	      conjoint: {
	        title: 'Conjoint(e)',
	        page: '#!/step3',
	        icon_img: imgConjoint,
	        available_datas: [],
	        no_data: 'Aucune donnée saisie',
	        step: 3
	      },
	      logement: {
	        title: 'Mon logement',
	        page: '#!/step4',
	        icon_img: imgLogement,
	        available_datas: [],
	        no_data: 'Aucune donnée saisie',
	        step: 4
	      },
	      ressources: {
	        title: 'Ressources',
	        page: '#!/step5',
	        icon_img: imgRessources,
	        available_datas: [],
	        no_data: 'Aucune ressources déclarée',
	        step: 5
	      },
	      avant_de_terminer:{
	        title: 'Avant de terminer',
	        page: '#!/step6',
	        icon_img: "/build/static/media/step6.9beac014cbaa860c6414.png",
	        available_datas: [],
	        step: 6
	      },
	    },

	};

	getRecapData = ()=>{
		var steps_data = this.state.recapData;
	    
	    Object.keys(steps_data).forEach ((type_data)=>{
			steps_data[type_data].available_datas = [];
			steps_data[type_data].is_current_step = steps_data[type_data].step === this.state.step;
		});

	    var demandeur = steps_data.demandeur.available_datas;
		var enfants = steps_data.enfants.available_datas;
		var conjoint = steps_data.conjoint.available_datas;
		var logement = steps_data.logement.available_datas;
		var ressources = steps_data.ressources.available_datas;


		init_recap( demandeur, enfants, conjoint, logement, ressources , this.state);

		steps_data.demandeur.saisi = !isNaN(this.state.demandeur.age);
		steps_data.enfants.saisi = this.state.enfantSaisi;
		steps_data.conjoint.saisi = typeof this.state.famille.en_couple!=='undefined';
		steps_data.logement.saisi = this.state.menage.statut_occupation_logement && this.state.menage.depcom;
		steps_data.ressources.saisi = typeof this.state.demandeur.ressources !== 'undefined';
		steps_data.avant_de_terminer.saisi = this.state.terminer ;


		return steps_data;

	}

	/* stepsboard et steps partagent l'etape active de la simulation */
	validateStep = ( newData  , updateOnly) => {
		// store data


		if ( typeof newData !== 'undefined' && this.state.step !== 2 ) {
			this.setState(  (state)  => {
				// merge current data with new data .
				var newState = {};
				Object.keys (newData ).forEach( (entity)=>{
					
					if ( newData[entity] === false){
						newState[entity] = undefined;
					}else{
						newState[entity] = { ...state[entity] , ...newData[entity]};
					}
				});
				return newState;
			});
		}else if ( this.state.step === 2 && typeof newData !== 'undefined' ){
			this.setState(  (state)  => {
				// merge current data with new data .
				var newState = {};
				Object.keys (newData ).forEach( (entity)=>{
					newState[entity] = newData[entity];
				});
				return newState;
			});
		}
		

		//increment step
		if (!updateOnly) {
			this.setState((state) => {
	  			return {
	  				step: state.step + 1,
	  				showDashboard : true
	  			};
			});
			let anchor = document.getElementById('anchor');
			anchor.scrollIntoView({ behavior: 'smooth' });
		}else {
			this.setState({ showDashboard : false,});
		}
		this.forceUpdate();
	}
	scrollIntoView = ()=> {
		let anchor = document.getElementById('anchor');
		anchor.scrollIntoView({ behavior: 'smooth' });
	}


	previousStep = () => {
		let anchor = document.getElementById('anchor');
		anchor.scrollIntoView({ behavior: 'smooth' });
		this.setState((state) => {
  			return {step: state.step - 1};
		});
	}

	forceStep = (choice) => {
		//force step to a value
		this.setState({
            step: choice
        });
        let anchor = document.getElementById('anchor');
		anchor.scrollIntoView({ behavior: 'smooth' });

	}

    restart = () => {
    	//Reinitialiser les données a chaque retour a l'étape 1
    	this.setState({ 
			step : 1,
			demandeur : {
				"role":"demandeur",
			},
			famille : {
				"parents":["individu"],
				"enfants":[]
			},
			menage : {
				"personne_de_reference":["individu"],
				"enfants":[],
				"conjoint":[]
			},
			foyer_fiscal : {
				"declarants":["individu"],
				"personnes_a_charge":[]
			},
			individus: {},
			showDashboard :true,
			terminer: false,
			enfantSaisi : false,
			recapData :{
		  demandeur: {
	        title: 'Mon profil',
	        icon_img: imgDemandeur,
	        page: '#!/step1',
	        available_datas: [],
	        no_data: 'Aucune donnée saisie',
	        step: 1
	      },
	      enfants: {
	        title: 'Mes enfants a charge(s)',
	        page: '#!/step2',
	        icon_img: "/build/static/media/step2.b4a377e50ff3712ad5bb.png",
	        available_datas: [],
	        no_data: 'Aucune donnée saisie',
	        step: 2
	      },
	      conjoint: {
	        title: 'Conjoint(e)',
	        page: '#!/step3',
	        icon_img: imgConjoint,
	        available_datas: [],
	        no_data: 'Aucune donnée saisie',
	        step: 3
	      },
	      logement: {
	        title: 'Mon logement',
	        page: '#!/step4',
	        icon_img: imgLogement,
	        available_datas: [],
	        no_data: 'Aucune donnée saisie',
	        step: 4
	      },
	      ressources: {
	        title: 'Ressources',
	        page: '#!/step5',
	        icon_img: imgRessources,
	        available_datas: [],
	        no_data: 'Aucune ressources déclarée',
	        step: 5
	      },
	      avant_de_terminer:{
	        title: 'Avant de terminer',
	        page: '#!/step6',
	        icon_img: "/build/static/media/step6.9beac014cbaa860c6414.png",
	        available_datas: [],
	        step: 6
	      },
	    },
		});
		// retour a l'étape 1
        this.forceStep(1); 
    }

    displayDashboard = ()=>{
    	this.setState( ({showDashboard})=>{
    		return {showDashboard :!showDashboard};
    	})
    }
    componentDidUpdate =  () => {
    	this.state.recapData = this.getRecapData();
    }
	render () {
		const displayDashboard= this.displayDashboard;
		return (
			<div className="Simulateur">
				<div id="anchor"> </div>
				<div className="App-header">
				<div className="top-head">
					<h2>Cliquez sur une des étapes</h2>
					<p>pour modifier les informations renseignées</p>
				</div>
				<DashboardMobile
					steps_data = {this.state.recapData}
					getRecapData = {this.getRecapData}
		      		step={this.state.step}
		      		forceStep={this.forceStep}
		      		currentStep ={this.state.step}
		      		restart = {this.restart}
		      		showDashboard ={this.state.showDashboard}
		      		displayDashboard = {this.displayDashboard}
		      	/>

				
	        <ul className="Stepsboard">
	          <li className={(this.state.step >= 1) ? "profile active" : "profile"} onClick={() => this.forceStep(1)} ><span ></span> <br/>Mon profil</li>
	          <li className={(this.state.step >= 2) ? "enfants active" : "enfants"} onClick={() => this.forceStep(2)} ><span ></span> <br/>Enfants</li>
	          <li className={(this.state.step >= 3) ? "conjoint active" : "conjoint"} onClick={() => this.forceStep(3)} ><span ></span> <br/>Conjoint(e)</li>
	          <li className={(this.state.step >= 4) ? "logement active" : "logement"} onClick={() => this.forceStep(4)} ><span ></span> <br/>Logement</li>
	          <li className={(this.state.step >= 5) ? "ressources active" : "ressources"} onClick={() => this.forceStep(5)} ><span ></span> <br/>Ressources</li>
	          <li className={(this.state.step >= 6) ? "fin active" : "fin"} onClick={() => this.forceStep(6)} ><span ></span> <br/>Avant de terminer</li>
	        </ul>
	      </div>
	      
	      <div className="Steps" >
	      	<Step 
	      		step={this.state.step}
	      		validateStep={this.validateStep}
	      		individus={this.state.individus}
	      		conjoint={this.state.conjoint}
	      		demandeur={this.state.demandeur}
	      		famille ={this.state.famille}
	      		foyer_fiscal ={this.state.foyer_fiscal}
	      		menage={this.state.menage}
	      		previousStep = {this.previousStep}
	      		definedRessources = {this.state.definedRessources}
                restart = {this.restart}

	      	/>
	      	<Recapitulation
	      		step={this.state.step}
	      		individus={this.state.individus}
	      		conjoint={this.state.conjoint}
	      		demandeur={this.state.demandeur}
	      		famille ={this.state.famille}
	      		foyer_fiscal ={this.state.foyer_fiscal}
	      		menage={this.state.menage}
	      		forceStep={this.forceStep}

	      	/>
	      </div>
      </div>
		)
	}
}

export default Simulateur;
